const component = "select-section-simple-tree";

export const selectSectionSimpleTree = {
  component,
  sectionItem: `${component}/section-item`,
  sectionName: `${component}/section-name`,
  sectionRootRadioButton: `${component}/section-root-radio-button`,
  sectionRadioButton: `${component}/section-radio-button`,
} as const;
